angular.module('autoremind.templates')
    .factory('templateAr2Service', [
    '$enhancedHttp', 'jobService', '$timeout', 'dialogs', 'Upload', '$uibModal', '$rootScope', '$q', '$httpQueue', '$window', 'accountService', '$location', 'userSettings',
    function ($enhancedHttp, jobService, $timeout, dialogs, $upload, $modal, $scope, $q, $httpQueue, $window, accountService, $location, userSettings) {
        return {
            loadingIndicator: {
                refCount: 0,
                state: true
            },
            userModel: {
                userId: null,
                templates: [],
                userCategorys: [],
                loadingIndicator: {
                    refCount: 0,
                    state: false
                }
            },
            autoremind2: {
                isCanLoad: true,
                isLoading: false,
                lastIndex: 0,
                templates: []
            },
            currentTemplate: null,
            clonedTemplateModel: null,
            languages: [],
            templateDefaultfolder: null,
            getUrlTemplates: function () {
                var templatesUrl = '/servlets/ar2/templates/all/';
                templatesUrl += '?offset=' + userSettings.model.ar2filters.offset
                    + '&sortby=' + userSettings.model.ar2filters.sortby
                    + '&order=' + (userSettings.model.ar2filters.order ? 'desc' : 'asc')
                    + '&type=' + (userSettings.model.ar2filters.type === 'all' ? '' : userSettings.model.ar2filters.type)
                    + '&language=' + userSettings.model.ar2filters.language
                    + '&displayName=' + userSettings.model.ar2filters.displayName
                    + '&fileName=' + userSettings.model.ar2filters.fileName
                    + '&userId=' + ((this.userModel.userId) ? this.userModel.userId : 0)
                    + '&hideOtherUsersTemplates=' + userSettings.model.ar2filters.hideOtherUsersTemplates
                    + '&hideDefault=' + userSettings.model.ar2filters.hideDefault
                    + '&hideNotInDefault=' + userSettings.model.ar2filters.hideNotInDefault
                    + '&hideV09=' + userSettings.model.ar2filters.hideV09;
                return templatesUrl;
            },
            getTemplates: function () {
                // if (this.autoremind2.templates.length > 0) {
                //     return;
                // }
                if (!this.autoremind2.isCanLoad || this.autoremind2.isLoading)
                    return;
                var url = this.getUrlTemplates();
                this.autoremind2.isLoading = true;
                var self = this;
                $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    errorMessage: 'Failed getting all templates from server',
                    disableErrorDialog: true,
                    retryBtn: false
                }, this.loadingIndicator)
                    .then(function (data) {
                    for (var i = 0; i < data.templatesAll.length; i++) {
                        var exist = false;
                        for (var x in self.autoremind2.templates) {
                            if (self.autoremind2.templates[x].templateId === data.templatesAll[i].templateId) {
                                exist = true;
                                break;
                            }
                        }
                        if (exist) {
                            continue;
                        }
                        data.templatesAll[i].sending = false;
                        data.templatesAll[i].editingTemplate = false;
                        data.templatesAll[i].isEdited = false;
                        self.autoremind2.templates.push(data.templatesAll[i]);
                    }
                    if (angular.isDefined(data.templateGetLimit)) {
                        userSettings.model.ar2filters.offset += parseInt(data.templateGetLimit);
                    }
                    if (angular.isDefined(data.templateGetLimit) && data.templatesAll.length < data.templateGetLimit) {
                        self.autoremind2.isCanLoad = false;
                    }
                    self.autoremind2.isLoading = false;
                }, function () {
                    self.autoremind2.isLoading = false;
                });
            },
            resetFilters: function (isFull) {
                if (isFull) {
                    userSettings.model.ar2filters.type = 'all';
                    userSettings.model.ar2filters.sortby = 'displayName';
                    userSettings.model.ar2filters.language = '';
                    userSettings.model.ar2filters.displayName = '';
                    userSettings.model.ar2filters.fileName = '';
                }
                userSettings.model.ar2filters.offset = 0;
                this.autoremind2.templates.length = 0;
                this.autoremind2.isCanLoad = true;
                this.currentTemplate = null;
                // this.clonedTemplateModel = null;
                this.getTemplates();
            },
            getUserTemplates: function () {
                var self = this;
                var url = '/servlets/ar2/templates/' + this.userModel.userId + '/';
                $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    errorMessage: 'Failed getting user templates from server',
                    disableErrorDialog: true,
                    retryBtn: false
                }, this.loadingIndicator)
                    .then(function (data) {
                    self.userModel.templates = data.templates;
                    console.log('getUserTemplates', data);
                    // self.autoremind2.templates = data.templatesAll;
                });
            },
            configMapTemplateToUser: function (isClone, template) {
                var modalInstance;
                var modalScope = $scope.$new();
                var self = this;
                modalScope.template = template;
                modalScope.isClone = isClone;
                modalScope.success = function (result) {
                    modalInstance.close(modalScope.selected);
                };
                modalScope.cancel = function () {
                    modalInstance.dismiss('cancel');
                };
                modalInstance = $modal.open({
                    template: '<set-template-to-user></set-template-to-user>',
                    size: 'lg',
                    scope: modalScope,
                    backdrop: 'static'
                });
            },
            setTemplateToUser: function (isClone, template, displayName, loadingIndicator) {
                console.log('setTemplateToUser');
                template.sending = true;
                var url = '/servlets/ar2/templates/' + template.templateId + '/' + this.userModel.userId + '/';
                var self = this;
                return $httpQueue({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    data: {
                        templateName: displayName,
                        type: template.type,
                        languageId: template.languageId
                    },
                    errorMessage: 'Error saving the data ',
                    disableErrorDialog: false,
                    stacking: { label: 'setTemplateToUser', isActive: true, type: template.type }
                }, loadingIndicator)
                    .then(function (data) {
                    if (angular.isDefined(data.rejectedFromQueue) && data.rejectedFromQueue && data.rejectedExist) {
                        template.sending = false;
                        return;
                    }
                    self.getUserTemplates();
                    template.sending = false;
                    return data;
                }, function (err) {
                    console.log(err);
                    self.getUserTemplates();
                    template.sending = false;
                    // if (isClone) {
                    //     self.showCloneErrorDialog();
                    // }
                    return err;
                });
            },
            getLanguages: function () {
                var deferred = $q.defer();
                if (this.languages.length === 0) {
                    var url = '/servlets/ar2/templates/languages/';
                    var self = this;
                    $enhancedHttp({
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' },
                        url: url,
                        errorMessage: 'Failed getting languages from server',
                        disableErrorDialog: true,
                        retryBtn: false
                    }, this.loadingIndicator)
                        .then(function (data) {
                        self.languages = data.languages;
                        deferred.resolve();
                    }, function () {
                        deferred.reject();
                    });
                }
                else {
                    $timeout(function () {
                        deferred.resolve();
                    }, 100);
                }
                return deferred.promise;
            },
            parseTemplate: function (templateName, loadingIndicator) {
                if (!loadingIndicator) {
                    loadingIndicator = this.loadingIndicator;
                }
                var url = '/servlets/ar2/templates/parsetemplate/?fileName=' + templateName;
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    errorMessage: 'Failed parsing data on the server',
                    disableErrorDialog: true,
                    retryBtn: false
                }, loadingIndicator);
            },
            registerTemplate: function (templateData) {
                var url = '/servlets/ar2/templates/new/';
                var self = this;
                return $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    data: templateData,
                    errorMessage: 'Error saving the data ',
                    disableErrorDialog: false
                })
                    .then(function (res) {
                    res.template.templateName = templateData.templateName;
                    if (angular.isDefined(res.template) && res.template.templateId) {
                        self.autoremind2.templates.push(res.template);
                        if (templateData.assignToUser) {
                            res.template.fileName = res.template.file;
                            self.userModel.templates.push(res.template);
                        }
                        self.clonedTemplateModel = res.template;
                    }
                    return res;
                }, function (err) {
                    console.log('registerTemplate', err);
                });
            },
            checkpathandtemplatename: function (data, loadingIndicator) {
                var url = '/servlets/ar2/templates/checkpathandtemplatename/?'
                    + 'userId=' + ((this.userModel.userId) ? this.userModel.userId.toString() : '0')
                    + '&fileName=' + data.fileName
                    + '&templateName=' + data.templateName
                    + '&type=' + data.type
                    + '&language=' + data.language;
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    errorMessage: 'Failed checking template on the server',
                    disableErrorDialog: false,
                    retryBtn: false
                }, loadingIndicator);
            },
            replaceTemplate: function (dataToRequest) {
                var url = '/servlets/ar2/templates/replacefile/';
                var self = this;
                return $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    data: dataToRequest,
                    errorMessage: 'Error saving the data ',
                    disableErrorDialog: false
                });
            },
            removeUserTemplate: function (template) {
                var self = this;
                dialogs.confirm('Warning', 'Are you sure you want to remove this template for current user?')
                    .result.then(function () {
                    self.confirmRemoveUserTemplate(template, true);
                }, function () {
                    return;
                });
            },
            confirmRemoveUserTemplate: function (template, isForce) {
                var self = this;
                var selectedUserId = accountService.selectedUserId;
                if (!selectedUserId) {
                    return;
                }
                var url = '/servlets/ar2/templates/account2template/' + template.account2templateId + '/';
                url += isForce ? '?force=true' : '';
                $enhancedHttp({
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    errorMessage: 'Failed removing template from server',
                    disableErrorDialog: true,
                    retryBtn: false
                }, this.userModel.loadingIndicator)
                    .then(function (data) {
                    for (var i in self.userModel.templates) {
                        if (self.userModel.templates[i].account2templateId === template.account2templateId) {
                            self.userModel.templates.splice(i, 1);
                            break;
                        }
                    }
                }, function (err) {
                });
            },
            getXmlTemplateForPreview: function (templateName, loadingIndicator) {
                var url = '/servlets/ar2/templates/content/?fileName=' + encodeURIComponent(templateName);
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    errorMessage: 'Failed getting template from the server',
                    disableErrorDialog: false,
                    retryBtn: false
                }, loadingIndicator);
            },
            uploadTemplateFile: function (file) {
                //console.log(file);
                return $upload.upload({
                    url: '/servlets/ar2/templates/upload/',
                    data: {
                        fileName: file.alias
                    },
                    file: file
                });
            },
            saveTemplate: function (templateData) {
                var url = '/servlets/ar2/templates/content/';
                var self = this;
                return $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    data: templateData,
                    errorMessage: 'Error saving the template ',
                    disableErrorDialog: false
                })
                    .then(function (res) {
                    if (angular.isDefined(res.template)) {
                        self.clonedTemplateModel = res.template;
                        self.resetFilters();
                    }
                    return res;
                });
            },
            previewEditTemplateDialog: function (template) {
                var deferred = $q.defer();
                var self = this;
                var modalInstance;
                var modalScope = $scope.$new();
                modalScope.template = template;
                modalScope.success = function (result) {
                    if (result.isCustomTemplate) {
                        result.template.sending = false;
                        result.template.editingTemplate = false;
                        result.template.isEdited = false;
                        self.autoremind2.templates.push(result.template);
                        self.getUserTemplates();
                        self.clonedTemplateModel = result.template;
                    }
                    else {
                        template.type = result.template.type;
                    }
                    modalInstance.close(modalScope.selected);
                    deferred.resolve({
                        result: result
                    });
                };
                modalScope.cancel = function () {
                    modalInstance.dismiss('cancel');
                    deferred.reject();
                };
                modalInstance = $modal.open({
                    template: '<preview-edit-template-ar2></preview-edit-template-ar2>',
                    size: 'lg',
                    scope: modalScope,
                    backdrop: 'static'
                });
                return deferred.promise;
            },
            saveTemplateAsCustom: function (data) {
                var url = '/servlets/ar2/templates/registerascustom/';
                var self = this;
                return $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    data: data,
                    errorMessage: 'Error saving the template ',
                    disableErrorDialog: false
                })
                    .then(function (res) {
                    if (angular.isDefined(res.template)) {
                        self.clonedTemplateModel = res.template;
                        self.resetFilters();
                        self.getUserTemplates();
                    }
                });
            },
            showErrorIfFileIsUsed: function (isDeleting) {
                var deferred = $q.defer();
                var msg = '';
                if (this.userModel.userId && !isDeleting) {
                    msg = 'This exact path and filename is already registered at least once and assigned to other users. Do you want to upload as a custom template for the user?';
                    dialogs.confirm('Editing of template', msg)
                        .result.then(function () {
                        deferred.resolve();
                    }, function () {
                        deferred.reject();
                    });
                }
                else {
                    msg = 'This exact path and filename is already registered at least once and assigned to at least one user. ';
                    var header = 'Editing of template';
                    if (isDeleting) {
                        msg += 'Deleting  not allowed!';
                        header = 'Deleting of template';
                    }
                    else {
                        msg += 'Replacing not allowed!';
                    }
                    dialogs.notify(header, msg);
                    $timeout(function () {
                        deferred.reject();
                    });
                }
                return deferred.promise;
            },
            hidingFilter: function (template) {
                var userFolder = template.file.match(/^\d+\//) || template.file.match(/\/\d+\//);
                userFolder = userFolder && userFolder[0] ? userFolder[0].replace(/\//g, '') : null;
                // if (userSettings.model.ar2filters.hideOtherUsersTemplates && userFolder && this.userModel.userId && userFolder !== this.userModel.userId.toString() && !template.file.match(/\/0\//)) {
                //     return;
                // }
                if (userSettings.model.ar2filters.hideAssignedTemplates && userFolder && this.userModel.userId && userFolder === this.userModel.userId.toString()) {
                    return;
                }
                // if (userSettings.model.ar2filters.hideDefault && template.file.match(/\/?default\//) ) {
                //     return;
                // }
                //
                // if (userSettings.model.ar2filters.hideV09 && template.file.match(/^v09|V09/) ) {
                //     return;
                // }
                return template;
            },
            useImages: function (model) {
                var url = '/servlets/ar2/templates/useimage/';
                return $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    data: model,
                    errorMessage: 'Error using the image',
                    disableErrorDialog: true
                });
            },
            checkImageOnExistence: function (fileName) {
                var url = '/servlets/ar2/templates/checkimageexistence/?fileName=' + encodeURIComponent(fileName);
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    errorMessage: 'Error checking if image exist on the server already',
                    disableErrorDialog: true
                });
            },
            selectUploadImagesDialog: function (config, model, file) {
                var deferred = $q.defer();
                var modalInstance;
                var modalScope = $scope.$new();
                modalScope.model = model ? angular.copy(model) : {};
                modalScope.model.file = file;
                modalScope.config = config ? config : {};
                // modalScope.templateFileName = templateFileName;
                modalScope.success = function (result) {
                    modalInstance.close(modalScope.selected);
                    deferred.resolve(result);
                };
                modalScope.cancel = function () {
                    modalInstance.dismiss('cancel');
                    deferred.reject();
                };
                modalInstance = $modal.open({
                    template: '<upload-select-images></upload-select-images>',
                    size: 'lg',
                    scope: modalScope,
                    backdrop: 'static'
                });
                return deferred.promise;
            },
            dirstructure: function (path, loadingIndicator) {
                var url = '/servlets/ar2/templates/dirstructure/?path=' + path;
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    errorMessage: 'Error getting the list of images on the server',
                    disableErrorDialog: true
                }, loadingIndicator);
            },
            downloadTemplate: function (templateName) {
                if (!angular.isDefined(templateName) || templateName === '') {
                    return;
                }
                var url = '/servlets/ar2/templates/download/?fileName=' + templateName;
                var fileName = templateName.substring(templateName.lastIndexOf('/') + 1);
                var click_ev = document.createEvent("MouseEvents");
                click_ev.initEvent("click", true, true);
                var anchor = angular.element('<a/>');
                anchor.attr({
                    href: url,
                    target: '_self',
                    download: templateName
                })[0].dispatchEvent(click_ev);
            },
            showUsersListForTemplate: function (template) {
                var deferred = $q.defer();
                var modalInstance;
                var modalScope = $scope.$new();
                modalScope.templateId = template.templateId;
                modalScope.templatesType = 'ar2';
                modalScope.success = function (user) {
                    modalInstance.close(modalScope.selected);
                    $location.search('userid', user.userId);
                    deferred.resolve();
                };
                modalScope.cancel = function () {
                    modalInstance.dismiss('cancel');
                    deferred.reject();
                };
                modalInstance = $modal.open({
                    template: '<users-list-for-template></users-list-for-template>',
                    size: 'lg',
                    scope: modalScope,
                    backdrop: 'static'
                });
                return deferred.promise;
            },
            confirmDeletingTemplate: function (template) {
                return dialogs.confirm('Deleting of template', 'Are you sure you want to delete (' + template.file + ') template?').result;
            },
            deleteTemplate: function (template) {
                var request = function () {
                    var url = '/servlets/ar2/templates/' + template.templateId + '/';
                    return $enhancedHttp({
                        method: 'DELETE',
                        headers: { 'Content-Type': 'application/json' },
                        url: url,
                        data: {
                            templateName: template.file
                        },
                        errorMessage: 'Error deleting template ',
                        disableErrorDialog: false
                    });
                };
                return this.confirmDeletingTemplate(template)
                    .then(function () {
                    return request();
                });
            },
            getUsersListByTemplateId: function (templateId, loadingIndicator) {
                var url = '/servlets/ar2/templates/assignedusersfortemplate/?templateId=' + templateId;
                return $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    errorMessage: 'Error getting the list of users on the server',
                    disableErrorDialog: true
                }, loadingIndicator);
            },
            getDefaultFolderName: function () {
                var url = '/servlets/ar2/templates/defaultfolder/';
                var self = this;
                $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    errorMessage: 'Error getting default template name ',
                    disableErrorDialog: false
                })
                    .then(function (res) {
                    if (angular.isDefined(res.defaultFolderName)) {
                        self.templateDefaultfolder = res.defaultFolderName + '/';
                    }
                });
            }
        };
    }
]);
//# sourceMappingURL=templates.ar2.services.js.map